import {Record} from "immutable";
import {
    onCategoriesChangeStatus, onCategoriesEdit, onCategoriesEditFail, onCategoriesEditSuccess,
    onCategoriesLoad,
    onCategoriesLoadFail,
    onCategoriesLoadSuccess, onCategoriesModalEdit, onCategoriesModalNew,
    onCategoriesNew,
    onCategoriesNewFail,
    onCategoriesNewSuccess,
} from "./actions";

const categories = new Record({
    modalNewCategory: false,
    modalEditCategory: false,
    menu_data_from_POS:[],
    loading: true,
    status: 'active',
    categories: []
})();

export default (state = categories, action) => {
    switch (action.type) {
        case onCategoriesLoad().type:
            return state.set('loading', true);

        case onCategoriesLoadSuccess().type:
            return state.set('loading', false)
                .set('categories', action.data.categories);

        case onCategoriesLoadFail().type:
            return state.set('loading', false);

        case onCategoriesChangeStatus().type:
            return state.set('status', action.status);


        case onCategoriesNew().type:
            return state.set('loading', true);
        case onCategoriesNewSuccess().type:
        case onCategoriesNewFail().type:
            return state.set('loading', false);

        case onCategoriesEdit().type:
            return state.set('loading', true);
        case onCategoriesEditSuccess().type:
        case onCategoriesEditFail().type:
            return state.set('loading', false);


        case onCategoriesModalNew().type:
            return state.set('modalNewCategory', action.show);
        case onCategoriesModalEdit().type:
            return state.set('modalEditCategory', action.show);



        default:
            return state;
    }
}
